import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import api from "../../lib/api";
import { CHANNEL_HREF, YtFrame } from "./LatestVideoHero";

export const ShortsRail = () => {
  const [shorts, setShorts] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/youtube/shorts", { params: { limit: 4 } })
      .then((r) => setShorts(Array.isArray(r.data) ? r.data : []))
      .catch(() => setShorts([]));
  }, []);

  if (!shorts.length) return null;

  return (
    <section className="py-14 sm:py-20" style={{ background: "#FFFFFF", borderTop: "1px solid rgba(0,0,0,0.06)" }} data-testid="home-shorts">
      <SectionHead kicker="YouTube Shorts" title="Gli ultimi Shorts." href={CHANNEL_HREF} cta="Tutti gli Shorts" testid="home-shorts-all" dark={false} />
      <div className="max-w-[1320px] mx-auto px-4 sm:px-8 flex lg:grid lg:grid-cols-4 gap-4 overflow-x-auto snap-x snap-mandatory scroll-px-4 sm:scroll-px-8 no-scrollbar">
        {shorts.map((s, i) => (
          <motion.div
            key={s.video_id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="relative shrink-0 w-[62vw] sm:w-[40vw] lg:w-auto snap-start overflow-hidden"
            style={{ aspectRatio: "9/16", background: "#111" }}
            data-testid={`home-short-${i}`}
          >
            {active === s.video_id ? (
              <YtFrame id={s.video_id} title={s.title} testid={`home-short-iframe-${i}`} />
            ) : (
              <ShortThumb s={s} onPlay={() => setActive(s.video_id)} />
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
};

function ShortThumb({ s, onPlay }) {
  return (
    <button type="button" onClick={onPlay} className="group absolute inset-0 w-full h-full text-left" aria-label={s.title}>
      <img src={`https://i.ytimg.com/vi/${s.video_id}/oardefault.jpg`} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = `https://i.ytimg.com/vi/${s.video_id}/hqdefault.jpg`; }} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <span className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0) 45%, rgba(0,0,0,0.85) 100%)" }} />
      <span className="absolute top-3 right-3 w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "rgba(255,40,0,0.92)" }}>
        <Play size={16} fill="#FFF" strokeWidth={0} className="ml-0.5" />
      </span>
      <span className="absolute bottom-0 left-0 right-0 p-4 text-[14px] line-clamp-3" style={{ color: "#FFF", lineHeight: 1.35 }}>{s.title}</span>
    </button>
  );
}

export const SectionHead = ({ kicker, title, href, cta, testid, dark = true }) => (
  <div className="max-w-[1320px] mx-auto px-4 sm:px-8 mb-8 sm:mb-10 flex flex-wrap items-end justify-between gap-4">
    <div>
      <div className="text-[11px] uppercase tracking-[0.3em] mb-3" style={{ color: "#FF2800" }}>{kicker}</div>
      <h2 className="text-3xl sm:text-5xl" style={{ color: dark ? "#FFF" : "#111", fontWeight: 300, letterSpacing: "-0.02em" }}>{title}</h2>
    </div>
    <a href={href} target="_blank" rel="noreferrer" className="text-[13px] uppercase tracking-[0.2em] underline underline-offset-4" style={{ color: dark ? "rgba(255,255,255,0.75)" : "#111" }} data-testid={testid}>
      {cta}
    </a>
  </div>
);
